import { CustomQuestionsStep } from "./CustomQuestionsStep";
import { AddonsStep } from "./AddonsStep.web";
import { LoginStep } from "./LoginStep.web";
import { ReviewStep } from "./ReviewStep";
import { PaymentStep } from "./PaymentStep";

export * from "./LoginStep.web";
export * from "./PaymentStep";
export * from "./ReviewStep";
export * from "./AddonsStep.web";
export * from "./CustomQuestionsStep";

export const CHECKOUT_STEP_IDS = [
  LoginStep.id,
  PaymentStep.id,
  ReviewStep.id,
  AddonsStep.id,
  CustomQuestionsStep.id,
];
